module.exports = __webpack_public_path__ + "img/closed_seasons.bab6883a.svg";